import { CategoryService } from './../category.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent implements OnInit {
  public faq_id = this.route.snapshot.paramMap.get('category_id');
  public form:FormGroup;
  public submitted = false;
  public image:File = null;
  public base_64_image:any;
  item: any;
  base_url = environment.baseUrl;
  constructor(private route:ActivatedRoute ,private router: Router,private formbuilder:FormBuilder,private service:CategoryService,private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    const list= JSON.parse(localStorage.getItem('sections'));
    console.log(list);
this.item=list.find((item :any )=> item.id==this.faq_id);
console.log(this.item);
this.base_64_image=this.base_url+this.item.image
    this.form = this.formbuilder.group({

      title:[this.item.title,Validators.required],
      description:[this.item.description,Validators.required],
      image:[this.base_url+this.item.image],


    })
  }

  detectImage(event) {
    const file = event.target.files[0];
    this.image = file
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        this.base_64_image = reader.result;
    };
  }
  get f() { return this.form.controls }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid ) { return }
    this.spinner.show()
    const form = {...this.form.value,image:this.image ,section_id:this.faq_id}
    console.log( form);

    this.service.update(form).subscribe((response:any)=>{
      this.spinner.hide()
      Swal.fire(
        `نجاح`,
        `تم تعديل القطاع`,
        `success`
      )
      this.router.navigate(["/app/category/list"])
    })
  }
}


